<router-outlet></router-outlet>
<app-loader></app-loader>
<app-no-internet-connection *ngIf="!isInternetConnected"></app-no-internet-connection>
<app-version-upgrade *ngIf="isNewerVersionOfAppAvailable"></app-version-upgrade>
<div id="overlayBackdrop"></div>